module.exports = __webpack_public_path__ + "img/suning.a4ebe0ae.png";